var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMergeRefs } from '@floating-ui/react';
import { C } from '#integrations';
import { SpinnerIcon } from '../../icons';
import { Tooltip, useTooltip } from '../../Tooltip';
import { IconButtonTestIdFactory } from '../interactions';
import { KINDS, SIZES, STATES } from './IconButton.constants';
import commonStyles from '../styles/Button.module.css';
import iconButtonStyles from './IconButton.module.css';
const SIZE_CLASS_MAP = {
    big: iconButtonStyles.Big,
    medium: iconButtonStyles.Medium,
    small: iconButtonStyles.Small,
};
const KIND_STATE_CLASS_MAP = {
    primary: {
        disabled: commonStyles.KindPrimaryDisabled,
        enabled: commonStyles.KindPrimaryEnabled,
        loading: iconButtonStyles.Loading,
    },
    secondary: {
        disabled: commonStyles.KindSecondaryDisabled,
        enabled: commonStyles.KindSecondaryEnabled,
        loading: iconButtonStyles.Loading,
    },
    danger: {
        disabled: commonStyles.KindDangerDisabled,
        enabled: commonStyles.KindDangerEnabled,
        loading: iconButtonStyles.Loading,
    },
    ghost: {
        disabled: commonStyles.KindGhostDisabled,
        enabled: C(commonStyles.KindGhostEnabled, iconButtonStyles.KindGhostEnabled),
        loading: iconButtonStyles.Loading,
    },
    'input-like': {
        disabled: iconButtonStyles.KindInputLikeDisabled,
        enabled: iconButtonStyles.KindInputLikeEnabled,
        loading: iconButtonStyles.KindInputLikeLoading,
    },
};
const ICON_SIZE_MAPPER = {
    big: 'middle',
    medium: 'small',
    small: 'xsmall',
};
const ROUNDING_CLASS_MAP = {
    big: iconButtonStyles.BorderRadius,
    medium: iconButtonStyles.BorderRadius,
    small: iconButtonStyles.BorderRadiusSmall,
};
export const IconButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, className, 'data-test-state': testState, 'data-testid': testid, disabled = false, Icon, isLoading = false, kind = KINDS.Primary, onBlur, onFocus, ref, size = SIZES.Medium, tooltipText, type = 'button', ...restButtonProps }) => {
    _react_refresh_temp_2();
    let state;
    if (isLoading) {
        state = STATES.Loading;
    }
    else if (disabled) {
        state = STATES.Disabled;
    }
    else {
        state = STATES.Enabled;
    }
    const iconButtonClassName = C(iconButtonStyles.Base, !disabled ? commonStyles.BaseEnabled : commonStyles.BaseDisabled, SIZE_CLASS_MAP[size], KIND_STATE_CLASS_MAP[kind][state], ROUNDING_CLASS_MAP[size], isLoading && commonStyles.Loading, className);
    const { isTooltipActive, refs, tooltipProps, triggerProps } = useTooltip();
    const tooltipTriggerProps = triggerProps;
    const mergedRef = useMergeRefs([ref, tooltipTriggerProps.ref]);
    return (_jsxs(_Fragment, { children: [_jsx("button", { "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, className: iconButtonClassName, "data-test-state": testState, "data-testid": IconButtonTestIdFactory.getIconButtonTestId(testid), disabled: disabled || isLoading, ...(tooltipText && {
                    onMouseEnter: tooltipTriggerProps.onMouseEnter,
                    onMouseLeave: tooltipTriggerProps.onMouseLeave,
                }), onBlur: (event) => {
                    if (tooltipText) {
                        tooltipTriggerProps.onBlur?.(event);
                    }
                    onBlur?.(event);
                }, onFocus: (event) => {
                    if (tooltipText) {
                        tooltipTriggerProps.onFocus?.(event);
                    }
                    onFocus?.(event);
                }, ref: tooltipText ? mergedRef : ref, type: type, ...restButtonProps, children: isLoading ? (_jsx(SpinnerIcon, { size: ICON_SIZE_MAPPER[size] })) : (_jsx(Icon, { size: ICON_SIZE_MAPPER[size] })) }), tooltipText &&
                isTooltipActive &&
                refs.reference.current !== null && (_jsx(Tooltip, { contents: [tooltipText], tooltipProps: tooltipProps }))] }));
};
_react_refresh_temp_1 = IconButton;
$RefreshReg$(_react_refresh_temp_1, "IconButton");
_react_refresh_temp_2(IconButton, "0o5xYYbZ/LVkEwyLff0FWB6kScs=", false, () => [useTooltip, useMergeRefs]);
